"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatePreviewModal = void 0;
const react_1 = __importStar(require("react"));
const doshx_controls_web_1 = require("doshx_controls_web");
const routes_1 = require("../../../../../constants/routes");
const get_document_1 = require("../../../../../api/calls/document/get_document");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const TemplatePreviewModal = ({ template }) => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [documentUrl, setDocumentUrl] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const [zoom, setZoom] = (0, react_1.useState)(100);
    const [isFullscreen, setIsFullscreen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const fetchDocument = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                setLoading(true);
                const response = yield (0, get_document_1.get_document)({ _id: template._id });
                if (response.success && ((_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.image)) {
                    setDocumentUrl(response.content.document.image);
                }
                else {
                    setError("Could not load document preview");
                }
            }
            catch (err) {
                console.error("Error fetching document:", err);
                setError("Failed to load document");
            }
            finally {
                setLoading(false);
            }
        });
        fetchDocument();
    }, [template._id]);
    const handleOpenFull = () => {
        window.open(`#${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${template === null || template === void 0 ? void 0 : template._id}`, "_blank");
    };
    const handleZoomIn = () => {
        setZoom((prev) => Math.min(prev + 25, 200));
    };
    const handleZoomOut = () => {
        setZoom((prev) => Math.max(prev - 25, 50));
    };
    const handleResetZoom = () => {
        setZoom(100);
    };
    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
    };
    const modalHeight = isFullscreen ? "h-screen" : "h-[80vh]";
    const modalWidth = isFullscreen ? "w-screen" : "w-full max-w-5xl";
    // Dynamic document size based on fullscreen mode
    const documentWidth = isFullscreen ? "1200px" : "800px";
    const documentHeight = isFullscreen ? "1500px" : "1000px";
    return (react_1.default.createElement("div", { className: `flex flex-col gap-4 bg-white p-4 ${modalHeight} ${modalWidth} mx-auto` },
        react_1.default.createElement("div", { className: "flex justify-between items-center flex-shrink-0" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h3", { className: "text-lg font-semibold text-gray-900" }, template.name),
                react_1.default.createElement("p", { className: "text-sm text-gray-500" },
                    template.pages,
                    " page",
                    template.pages !== 1 ? "s" : "",
                    " \u2022 ",
                    template.status)),
            react_1.default.createElement("div", { className: "flex items-center gap-2" },
                react_1.default.createElement("div", { className: "flex items-center gap-1 bg-gray-100 rounded-md p-1" },
                    react_1.default.createElement("div", { className: zoom <= 50 ? "opacity-50 pointer-events-none" : "" },
                        react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faMagnifyingGlassMinus, onClick: handleZoomOut, size: "xsmall", backgroundColor: "bg-white", borderColor: "border-gray-200", iconColor: "text-gray-700" })),
                    react_1.default.createElement("button", { onClick: handleResetZoom, className: "px-2 py-1 text-xs font-medium text-gray-700 hover:bg-white rounded" },
                        zoom,
                        "%"),
                    react_1.default.createElement("div", { className: zoom >= 200 ? "opacity-50 pointer-events-none" : "" },
                        react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faMagnifyingGlassPlus, onClick: handleZoomIn, size: "xsmall", backgroundColor: "bg-white", borderColor: "border-gray-200", iconColor: "text-gray-700" }))),
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: isFullscreen ? pro_light_svg_icons_1.faCompress : pro_light_svg_icons_1.faExpand, onClick: toggleFullscreen, size: "small", backgroundColor: "bg-gray-100", borderColor: "border-gray-200", iconColor: "text-gray-700" }),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Open Full Editor", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: handleOpenFull }))),
        react_1.default.createElement("div", { className: "flex-1 overflow-auto bg-gray-50 rounded-lg relative" },
            loading && (react_1.default.createElement("div", { className: "absolute inset-0 flex items-center justify-center z-10" },
                react_1.default.createElement("div", { className: "flex flex-col items-center" },
                    react_1.default.createElement("div", { className: "w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin mb-2" }),
                    react_1.default.createElement("p", { className: "text-sm text-gray-500" }, "Loading preview...")))),
            error && (react_1.default.createElement("div", { className: "absolute inset-0 flex items-center justify-center z-10" },
                react_1.default.createElement("div", { className: "flex flex-col items-center text-gray-400" },
                    react_1.default.createElement("svg", { className: "w-16 h-16 mb-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" },
                        react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })),
                    react_1.default.createElement("p", { className: "text-sm" }, error)))),
            !loading && !error && documentUrl && (react_1.default.createElement("div", { className: "w-full h-full flex items-center justify-center p-4" },
                react_1.default.createElement("div", { style: {
                        transform: `scale(${zoom / 100})`,
                        transformOrigin: "center center",
                        transition: "transform 0.2s ease-in-out, width 0.2s ease-in-out, height 0.2s ease-in-out",
                    }, className: "shadow-lg" },
                    react_1.default.createElement("embed", { src: documentUrl, type: "application/pdf", className: "border-0", style: {
                            width: documentWidth,
                            height: documentHeight,
                            transition: "width 0.2s ease-in-out, height 0.2s ease-in-out",
                        }, title: `Preview: ${template.name}` }))))),
        !isFullscreen && (react_1.default.createElement("div", { className: "flex justify-between text-xs text-gray-500 pt-2 border-t flex-shrink-0" },
            react_1.default.createElement("span", null,
                "Template ID: ",
                template._id),
            react_1.default.createElement("span", null,
                "Type: ",
                template.type)))));
};
exports.TemplatePreviewModal = TemplatePreviewModal;
